const popups = {
    trigersToggle: [{
            name: 'menu',
            open: [document.getElementById('openMenu')],
            popup: document.getElementById('menu'),
            close: document.getElementById('closeMenu')
        },
        {
            name: 'search',
            open: document.querySelectorAll('.jsSearchOpen'),
            popup: document.getElementById('searchWrap'),
            close: document.getElementById('closeSearch')
        }, 
        {
            name: 'sidebar',
            open: [document.getElementById('openSidebar')],
            popup: document.getElementById('leftSidebar'),
            close: document.getElementById('closeSub')
        },
        {
            name: 'form',
            open: [document.getElementById('openForm')],
            popup: document.getElementById('formPopup'),
            close: document.getElementById('closeForm')
        },

    ], 
    clearFilters: document.getElementById('clearFilters'),
    overlay: document.getElementById('overlay'),
    close: document.querySelectorAll('.jsClose'),
    activClasse: [],
    menuAdvert: document.getElementById('phoneAdvert'),

    init() {
        this.openPopupToggle();
        this.overlayClose();    
        this.clearFilter();
    },
    clearFilter() {
        if (this.clearFilters) {
            let link = window.location;
            this.clearFilters.addEventListener('click', () => {
                window.location.replace(link.origin + link.pathname);
            });
        }

    },
    overlayClose() {
        this.overlay.addEventListener('click', () => {
            this.overlay.classList.remove('activeClass');
            document.documentElement.style.overflow = 'auto';
            document.body.style.overflow = 'auto';
            this.closeAll();
        });
    },

    setOverlay(open, popup, triger) {
        if (open) {
            this.closeAll();
            this.overlay.classList.add('activeClass');
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            popup.classList.add('activeClass');
            triger.dataset.open = 'true';
            triger.classList.add('activeClass');
            this.activClasse.push(popup);
            this.activClasse.push(triger);
        } else {
            this.overlay.classList.remove('activeClass');
            triger.dataset.open = 'false';
            document.documentElement.style.overflow = 'auto';
            document.body.style.overflow = 'auto';
            this.closeAll();
        }
    },
    closeAll() {
        this.activClasse.forEach((item) => {
            item.classList.remove('activeClass');
            item.dataset.open = 'false';
        });
        this.activClasse = [];
    },
    openPopupToggle() {
        this.trigersToggle.forEach((item, index) => {
            if (item['open'][0]) {
                item['open'].forEach(el => {
                    item['popup'].classList.add('init');
                    el.addEventListener('click', (e) => {
                        e.preventDefault();
                      
                        if (el.dataset.open === 'false') {
                            this.setOverlay(true, item['popup'], el);
                        } else {
                            this.setOverlay(false, item['popup'], el);
                        }
                    })
                });

                if (item['close']) {
                    item['close'].addEventListener('click', () => {

                        item['open'].forEach(el => {
                            this.setOverlay(false, item['popup'], el);
                        });
                    })
                }
            }


        });
    },


}

export default popups;